import React from "react";
import CommunityAddPage from "../community/components/CommunityAddPage";
import { IMMEDIATE_HELP } from "../community/constants";
import { useRequireSectionVisible } from "../../client/hooks/useRequireSectionVisible";

export default function AddImmediateHelpPage() {
  useRequireSectionVisible("showUrgentHelp");
  return <CommunityAddPage section={IMMEDIATE_HELP} />;
}
